import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createCarousel,
  setCarouselImage,
  setCarouselLink,
  setSelectedType,
  setSequence,
  updateCarousel,
  setTiming
} from "../../features/carouselSlice";
import Spinner from "../../components/spinner/Spinner";
import Button from "../../components/button/Button";
import { errorToastify, successToastify } from "../../utils/toastify.util";
import instance from "../../utils/api_instance.util";
import { basicModalShowHide } from "../../features/modalSlice";
import IapImageCropperModal from "../../components/image/IapImageCropperModal.jsx";
import { fetchItemGroupListAPI } from "../../apis/item.api.js";
import { fetchQuestPackListAPI } from "../../apis/questPack.api.js";
import { fetchHuntPackListAPI } from "../../apis/huntPack.api.js";
import {
  CAROUSEL_CROP_HEIGHT,
  CAROUSEL_CROP_WIDTH,
  carouselDestination,
  carouselLinkFor,
  rowsOf,
} from "../../utils/carouselLink.util.js";

const CarouselModal = () => {
  const dispatch = useDispatch();
  const {
    editId,
    type,
    edit_type,
    selectedType,
    carouselImage,
    carouselLink_Url,
    sequence,
    isAdd,
    isEdit,
    timing,
  } = useSelector((state) => state.carousel);
  const [isImgUpload, setIsImgUpload] = useState(false);
  const [carouselCropState, setCarouselCropState] = useState({
    isOpen: false,
    imageSrc: "",
    fileName: "carousel-image.jpg",
  });
  const imageInputRef = useRef(null);
  const parsedLink = carouselDestination(carouselLink_Url);
  const [pendingKind, setPendingKind] = useState(null);
  const [catalog, setCatalog] = useState([]);
  const kind = pendingKind || parsedLink.kind;

  useEffect(() => {
    setPendingKind(null);
  }, [editId, isEdit]);

  useEffect(() => {
    if (kind !== "item" && kind !== "quest" && kind !== "hunt") return undefined;
    let cancelled = false;
    const load = kind === "item"
      ? fetchItemGroupListAPI({ limit: 200, offset: 0 })
      : kind === "quest"
        ? fetchQuestPackListAPI({ limit: 200, offset: 0 })
        : fetchHuntPackListAPI({ limit: 200, offset: 0 });
    load
      .then((data) => {
        if (!cancelled) setCatalog(rowsOf(data));
      })
      .catch(() => {
        if (!cancelled) setCatalog([]);
      });
    return () => {
      cancelled = true;
    };
  }, [kind]);

  const chooseKind = (next) => {
    setPendingKind(next === "none" ? null : next);
    if (next === "web") {
      dispatch(setCarouselLink(parsedLink.kind === "web" ? parsedLink.url : ""));
      return;
    }
    if (next === "item" || next === "quest" || next === "hunt") {
      dispatch(setCarouselLink(""));
      return;
    }
    dispatch(setCarouselLink(carouselLinkFor(next)));
  };

  const handleCloseImg = () => {
    dispatch(setCarouselImage(""));
  };

  const buildCroppedFileName = (originalName, prefix) => {
    const safePrefix = prefix || "cropped-image";
    const sourceName = String(originalName || "").trim();
    const baseName = sourceName.replace(/\.[^/.]+$/, "") || safePrefix;
    const normalizedBase = baseName
      .replace(/[^a-zA-Z0-9-_]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .toLowerCase();

    return `${normalizedBase || safePrefix}-${Date.now()}.jpg`;
  };

  const closeCarouselCropper = () => {
    if (carouselCropState.imageSrc) {
      URL.revokeObjectURL(carouselCropState.imageSrc);
    }
    setCarouselCropState({
      isOpen: false,
      imageSrc: "",
      fileName: "carousel-image.jpg",
    });
  };

  const uploadCarouselImageBlob = async (blob) => {
    try {
      setIsImgUpload(true);
      const fileData = new FormData();
      const uploadFile = new File(
        [blob],
        buildCroppedFileName(carouselCropState.fileName, "carousel-image"),
        { type: "image/jpeg" },
      );
      fileData.append("file", uploadFile);
      const { data } = await instance.post(
        `/api/v1/common/file/upload`,
        fileData,
      );
      if (data.success) {
        successToastify(data.mesasge || data.message || "Uploaded");
        dispatch(setCarouselImage(data.result.url));
        closeCarouselCropper();
      }
    } catch (err) {
      errorToastify(err?.response?.data?.message || "Carousel image upload failed");
    } finally {
      setIsImgUpload(false);
    }
  };

  const fileUploadImg = (event) => {
    const file = event.currentTarget.files?.[0];
    if (!file) return;

    setCarouselCropState({
      isOpen: true,
      imageSrc: URL.createObjectURL(file),
      fileName: file.name || "carousel-image.jpg",
    });
    event.target.value = "";
  };

  // Method to trigger the hidden Banner Image file input
  const triggerFileInputBanner = () => {
    imageInputRef.current?.click();
  };

  const addCarouselData = async () => {
    let errorCount = 0;
    if (selectedType === "") {
      errorToastify("Please select type");
      errorCount++;
      return false;
    } else if (carouselImage === "") {
      errorToastify("Please Upload an image");
      errorCount++;
      return false;
    } else if (timing === 0 || timing === "") {
      errorToastify("Please add time");
      errorCount++;
      return false;
    } else if ((kind === "item" || kind === "quest" || kind === "hunt") && !parsedLink.id) {
      errorToastify("Please choose what this slide opens");
      errorCount++;
      return false;
    }
    if (errorCount === 0) {
      let req = {
        type: selectedType,
        img_url: carouselImage,
        link_url: carouselLink_Url || null,
        sequence: sequence,
        timing: timing,
      };
      console.log("REQ>>>>>>>>", req);
      if (isEdit) {
        dispatch(
          updateCarousel({
            id: editId,
            type: selectedType,
            img_url: carouselImage,
            link_url: carouselLink_Url || null,
            sequence: sequence,
            timing: timing,
          }),
        );
      } else {
        dispatch(createCarousel(req));
      }
      dispatch(basicModalShowHide());
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mb-3">
          <label htmlFor="exampleSelect" className="form-label">
            Select Type:
          </label>
          <select
            className="form-select"
            id="exampleSelect"
            value={selectedType}
            onChange={(e) => dispatch(setSelectedType(e.target.value))}
          >
            <option value="">Select an option</option>
            {isEdit
              ? edit_type.map((item, key) => (
                  <option value={item.value} key={"type_" + key}>
                    {item.label}
                  </option>
                ))
              : type.map((item, key) => (
                  <option value={item.value} key={"type_" + key}>
                    {item.label}
                  </option>
                ))}
          </select>
        </div>
        <div className="col-md-12 mb-3">
          <label htmlFor="carousel_destination" className="form-label">
            When the slide is tapped
          </label>
          <select
            className="form-select"
            id="carousel_destination"
            value={kind === "none" ? "none" : kind}
            onChange={(e) => chooseKind(e.target.value)}
          >
            <option value="none">Nothing</option>
            <option value="web">Open a web link</option>
            <option value="store">Open the store</option>
            <option value="learn">Open the tutorial</option>
            <option value="credits">Buy hunt credits</option>
            <option value="item">Open a store item</option>
            <option value="quest">Open a quest pack</option>
            <option value="hunt">Open a hunt pack</option>
          </select>
          {kind === "web" && (
            <input
              type="text"
              id="link_url"
              className="form-control mt-2"
              value={carouselLink_Url}
              onChange={(e) => dispatch(setCarouselLink(e.target.value))}
              placeholder="https://example.com"
            />
          )}
          {(kind === "item" || kind === "quest" || kind === "hunt") && (
            <select
              className="form-select mt-2"
              value={parsedLink.id || ""}
              onChange={(e) => {
                setPendingKind(null);
                dispatch(setCarouselLink(carouselLinkFor(kind, { id: e.target.value })));
              }}
            >
              <option value="">Select</option>
              {catalog.map((row) => (
                <option value={row.id} key={`${kind}_${row.id}`}>
                  {row.name}
                </option>
              ))}
              {parsedLink.id && !catalog.some((row) => row.id === parsedLink.id) && (
                <option value={parsedLink.id}>{parsedLink.id}</option>
              )}
            </select>
          )}
          {kind !== "none" && (
            <div className="text-muted small mt-1">
              The More button shows on this slide in the app.
            </div>
          )}
        </div>
        <div className="col-md-12 mb-3">
          <label htmlFor="link_url" className="form-label">
            Sequence
          </label>
          <input
            type="text"
            id="sequence"
            className="form-control"
            value={sequence}
            onChange={(e) => dispatch(setSequence(e.target.value))}
            placeholder="0"
          />
        </div>
        <div className="col-md-12 mb-3">
          <label htmlFor="link_url" className="form-label">
            Timing (in second)
          </label>
          <input
            type="text"
            id="timing"
            className="form-control"
            value={timing}
            onChange={(e) => dispatch(setTiming(e.target.value))}
            placeholder="0"
          />
        </div>
        <div className="col-md-12 mb-3">
          <label htmlFor="discount_banner_image" className="form-label fs-7">
            Carousel Image (3:2, same shape as the home banner)
          </label>
          <br />
          {carouselImage ? (
            <div
              style={{
                position: "relative",
                width: "240px",
                aspectRatio: "3 / 2",
                borderRadius: "10px",
                overflow: "hidden",
                border: "1px solid rgba(15, 23, 42, 0.12)",
                backgroundColor: "#f8fafc",
              }}
            >
              <img
                src={carouselImage}
                alt="Carousel_image"
                style={{ width: "100%", height: "100%", objectFit: "fill" }}
              />
              {kind !== "none" && (
                <img
                  src="/carousel-more.png"
                  alt=""
                  style={{
                    position: "absolute",
                    left: "4%",
                    bottom: "6%",
                    width: "42%",
                    pointerEvents: "none",
                  }}
                />
              )}
              <button
                type="button"
                onClick={handleCloseImg}
                className="logo_close_btn"
              >
                &times;
              </button>
            </div>
          ) : (
            <>
              {isImgUpload ? (
                <Spinner />
              ) : (
                <>
                  <input
                    ref={imageInputRef}
                    id="carousel_image"
                    name="carousel_image"
                    type="file"
                    accept="image/*"
                    onChange={(event) => fileUploadImg(event)}
                    style={{ display: "none" }}
                  />
                  <Button
                    type="button"
                    className="btn btn-sm btn-outline-primary me-2"
                    title="Add Carousel Image"
                    onClick={() => triggerFileInputBanner()}
                  >
                    <i className="fa-solid fa-upload"></i>
                  </Button>
                </>
              )}
            </>
          )}
        </div>
        <IapImageCropperModal
          isOpen={carouselCropState.isOpen}
          imageSrc={carouselCropState.imageSrc}
          onCancel={closeCarouselCropper}
          onConfirm={uploadCarouselImageBlob}
          title="Crop Carousel Image"
          targetWidth={CAROUSEL_CROP_WIDTH}
          targetHeight={CAROUSEL_CROP_HEIGHT}
        />

        <div className="col-12 mb-3">
          <button
            className="btn btn-primary w-100"
            type="button"
            disabled={isAdd}
            onClick={() => addCarouselData()}
          >
            {isAdd ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              <>{isEdit ? "Update" : "Add"}</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarouselModal;
